module.exports = __webpack_public_path__ + "img/x.4e3d78e2.svg";